<template>
  <div class="main-box">
    <p class="title-crumb" @click="go()" style="cursor: pointer;">
      <i class="el-icon-back"></i>
      <el-breadcrumb separator-class="el-icon-arrow-right color3">
        <el-breadcrumb-item>特种设备操作人员列表</el-breadcrumb-item>
      </el-breadcrumb>
    </p>
    <div class="box-content">
      <div class="head">
        <el-date-picker
          v-model="time"
          value-format="yyyy-MM-dd"
          type="date"
          @change="doFilter"
          placeholder="选择日期"
        >
        </el-date-picker>
        <div></div>
        <div></div>
      </div>
      <div class="content1">
        <el-table :data="tableData" height="100%" border style="width: 100%;">
          <!-- <template slot="empty">
              <p>{{dataText}}</p>
          </template> -->
          <el-table-column label="序号" width="80">
              <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
              </template>
          </el-table-column>
          <el-table-column label="姓名" prop="name">
          </el-table-column>
          <el-table-column prop="certificateNumber"
                                label="证件编号">
          </el-table-column>
          <el-table-column
                                prop="certificatePhoto"
                                label="查看证书">
                                <template slot-scope="scope">
                                    <el-image
                                        v-if="scope.row.certificatePhoto!=''"
                                        style="width: 6vh; height: 6vh;"
                                        :src="scope.row.certificatePhoto"
                                        :preview-src-list="scope.row.photoList"
                                    ></el-image>
                                    <div v-else class="no-photo" style="display: inline-block;">
                                        <span style="display: block;">暂无</span>
                                        <span style="display: block;">图片</span>
                                    </div>
                                </template>
                            </el-table-column>
          <el-table-column label="操作记录" >
                                <template slot-scope="scope">
                                    <div style="height:100px;display: flex;align-content: center;align-items: center;justify-content: center;">
                                        <el-image
                                            v-if="scope.row.photoFile!=''"
                                            style="width: 6vh; height: 6vh;"
                                            :src="scope.row.photoFile"
                                            :preview-src-list="scope.row.photoList"
                                        ></el-image>
                                        <span style="margin-left:1vh;">时间：{{scope.row.clockTime}}</span>
                                    </div>
                                </template>
                            </el-table-column>
          
        </el-table>
        <!-- 表单列表 -->
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
  data() {
    return {
      deviceId: '',
      groupId: '',
      time:util.myTime.getCurTime(),
      // time: '2020-11-09',
      // listTh: [
      //   '高度预警',
      //   '速度预警',
      //   '姿态状态预警',
      //   '重量状态预警',
      //   '',
      // ],
      tableData: [],
      // frontList:[],
      // behindList:[],
      // tiltList:[],
      // weightList:[],
      // lijupercentList:[],
      // createDateList:[],
      // pengzhuangList:[],
      // windspeedList:[],
      dataText:'数据加载中...',
      currentPage: 1, // 表单列表默认页
      pageSize: 10, // 表单列表默认显示数
      totalItems: 0, // 表单列表全部长度,
      towerlist:[]
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.deviceId = this.$route.params.id
    // this.getData()
    this.tableData = this.$route.query.row
    this.getTowerList()
  },
  methods: {

            //获取塔吊设备
        getTowerList(){
            var that = this
            myHttp.getTowerListByPage({
                projectId:this.groupId
            }).then(function(resp){
                console.log(resp,'123123')
                if(resp.data.code=='200'){
                    var list = resp.data.data.towerList||[]
                    for(var i=0;i<list.length;i++){
                        if(list[i].machType=='3'){
                            list[i].online = list[i].connectedStatus && ''!=list[i].connectedStatus?list[i].connectedStatus:'离线'
                        }else{
                            if(list[i].status=='0'){
                                list[i].online = '离线'
                            }else if(list[i].status=='1'){
                                list[i].online = '在线'
                            }else{
                              list[i].online = '异常'
                            }
                        }

                    }
                    // that.row = list[0]
                    that.towerlist = list
                    that.getPerson()
                }
            })
        },
    //获取人员操作记录
        getPerson(){
            var that = this
            myHttp.getTzListByTeamsId({
                projectId:this.groupId,
                teamsId:this.getTeamId(this.deviceId),
                daysss:this.time,
                status:'1',
                attendanceSn:this.getSn(this.deviceId)
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.attendList||[]
                    for(var i=0;i<list.length;i++){
                        list[i].certificatePhoto = list[i].certificatePhoto && list[i].certificatePhoto!=''?base.httpCtx+list[i].certificatePhoto:''
                        list[i].photoList = []
                        if(list[i].certificatePhoto!=''){
                            list[i].photoList.push(list[i].certificatePhoto)
                        }
                        list[i].photoFile = list[i].photoFile && ''!=list[i].photoFile?base.httpCtx+list[i].photoFile:''
                        if(list[i].photoFile!=''){
                            list[i].photoList.push(list[i].photoFile)
                        }
                        list[i].index = (i+1)
                    }
                    that.tableData = list
                }
            })
        },
        //获取班组id
        getTeamId(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].teamsId
                }
            }
            return result
        },
        //获取sn
        getSn(id){
            var list = this.towerlist
            var result = ''
            for(var i=0;i<list.length;i++){
                if(id==list[i].deviceId){
                    result = list[i].attendanceSn
                }
            }
            return result
        },
    doFilter(){
      // this.currentPage = 1
      // this.getData()
      this.getPerson()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getData()
    },
    // 监控当前页码
    currentChangePage() {
      this.getData()
    },
    //获取列表
    // getData(){
    //   var that = this
    //   myHttp.towerMore({
    //     projectId:this.groupId,
    //     deviceId:this.deviceId,
    //     date:this.time,
    //     pageNum:this.currentPage,
    //     pageSize:this.pageSize
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var list = resp.data.data.list.list||[]
    //       for(var i=0;i<list.length;i++){
    //         list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
    //         // list[i].name = ''
    //         // if(list[i].heightStatus&&list[i].heightStatus!='正常'){
    //         //   list[i].name += list[i].name==''?list[i].heightStatus:','+list[i].heightStatus
    //         // }
    //         // if(list[i].speedStatus&&list[i].speedStatus!='正常'){
    //         //   list[i].name += list[i].name==''?list[i].speedStatus:','+list[i].speedStatus
    //         // }
    //         // if(list[i].tiltStatus && list[i].tiltStatus!='正常'){
    //         //   list[i].name += list[i].name==''?list[i].tiltStatus:','+list[i].tiltStatus
    //         // }
    //         // if(list[i].weightStatus && list[i].weightStatus!='正常'){
    //         //   list[i].name += list[i].name==''?list[i].weightStatus:','+list[i].weightStatus
    //         // }
    //         list[i].radius = parseFloat(list[i].radius).toFixed(2)
    //       }
    //       that.tableData = list
    //       that.totalItems = resp.data.data.list.total||0
    //       if(list.length==0){
    //         that.dataText = '暂无数据'
    //       }
    //     }else{
    //       that.dataText = '暂无数据'
    //     }
    //   },function(){that.dataText = '暂无数据'})
    // },

    //判断是否预警
    isWarnFlag(id,str){
      var result = false
      if(str){
        var list = str.split(',')
        console.log(id,list)
        for(var i=0;i<list.length;i++){
          if(id==list[i]){
            result = true
          }
        }
      }
      return result
    },
    //
    // getData() {
    //   var that = this
    //   myHttp.elevatorLogTimeQuantum({
    //       deviceId: this.deviceId,
    //       projectId: this.groupId,
    //       createDate:this.time
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data
    //       var createDateList = ['00:00','01:00','02:00','03:00','04:00','05:00','06:00','07:00','08:00','09:00','10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00','18:00','19:00','20:00','21:00','22:00','23:00']
    //       var frontList = []
    //       var behindList=[]
    //       var tiltList =[]
    //       var weightList = []
    //       for(var i=0;i<createDateList.length;i++){
    //         //高度
    //         frontList.push('--')
    //         var list1 = data.heightWarnTimeQuantum||[]
    //         for(var j=0;j<list1.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list1[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             frontList[i] = list1[j].warnTimes
    //           }
    //         }
    //         //速度
    //         behindList.push('--')
    //         var list2 = data.speedWarnTimeQuantum||[]
    //         for(var j=0;j<list2.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list2[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             behindList[i] = list2[j].warnTimes
    //           }
    //         }
    //         //姿态
    //         tiltList.push('--')
    //         var list3 = data.tiltWarnTimeQuantum||[]
    //         for(var j=0;j<list3.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list3[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             tiltList[i] = list3[j].warnTimes
    //           }
    //         }
    //         //重量
    //         weightList.push('--')
    //         var list4 = data.weightWarnTimeQuantum||[]
    //         for(var j=0;j<list4.length;j++){
    //           var it = createDateList[i].split(':')[0]
    //           var ft = list4[j].timeQuantum.split(' ')[1].split(':')[0]
    //           if(it == ft){
    //             weightList[i] = list4[j].warnTimes
    //           }
    //         }
    //       }
    //       that.frontList = frontList
    //       that.behindList = behindList
    //       that.tiltList = tiltList
    //       that.weightList = weightList
    //       that.createDateList = createDateList
    //     }
    //   })
    //},
    isData(arr){
      for(var i = 0;i<arr.length;i++){
         arr[i]=arr[i]>0?arr[i]:'--'
      }
      return arr
    },
    go() {
      this.$router.go(-1)
    },
  },
}
</script>
<style scoped>
.main-box {
  width: 100%;
  height: 100%;
  position: relative;
  padding:0 1vh;
}
.box-content {
  width: 100%;
  height: calc(100% - 5vh);
  background: #fff;
}
.head {
  display: flex;
  height: 6vh;
  padding: 1vh;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #409EFF;
}
.content1 {
  /* display: flex; */
  height: calc(100% - 12vh);
}
.ulhead {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.ulhead2 {
  display: flex;
}
.listy{
 height: 40px;
 padding: 1vh;

}
.colorBg{
 background: #f4f7fc;
}
.color{
 color: #f00;
}
</style>